export const GET_PROMOCODE_PENDING = 'GET_PROMOCODE_PENDING'
export const GET_PROMOCODE_SUCCESS = 'GET_PROMOCODE_SUCCESS'
export const GET_PROMOCODE_REJECT = 'GET_PROMOCODE_REJECT'

export const POST_SUBSCRIPTIONS_PROMOCODE_PENDING = 'POST_SUBSCRIPTIONS_PROMOCODE_PENDING'
export const POST_SUBSCRIPTIONS_PROMOCODE_SUCCESS = 'POST_SUBSCRIPTIONS_PROMOCODE_SUCCESS'
export const POST_SUBSCRIPTIONS_PROMOCODE_REJECT = 'POST_SUBSCRIPTIONS_PROMOCODE_REJECT'

export const PATCH_SUBSCRIPTION_PENDING = 'PATCH_SUBSCRIPTION_PENDING'
export const PATCH_SUBSCRIPTION_SUCCESS = 'PATCH_SUBSCRIPTION_SUCCESS'
export const PATCH_SUBSCRIPTION_REJECT = 'PATCH_SUBSCRIPTION_REJECT'

export const GET_ACCOUNT_PENDING = 'GET_ACCOUNT_PENDING'
export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS'
export const GET_ACCOUNT_REJECT = 'GET_ACCOUNT_REJECT'

export const PATCH_ACCOUNT_PENDING = 'PATCH_ACCOUNT_PENDING'
export const PATCH_ACCOUNT_SUCCESS = 'PATCH_ACCOUNT_SUCCESS'
export const PATCH_ACCOUNT_REJECT = 'PATCH_ACCOUNT_REJECT'

export const DELETE_SESSION_UNAUTHORIZE_PENDING = 'DELETE_SESSION_UNAUTHORIZE_PENDING'
export const DELETE_SESSION_UNAUTHORIZE_SUCCESS = 'DELETE_SESSION_UNAUTHORIZE_SUCCESS'
export const DELETE_SESSION_UNAUTHORIZE_REJECT = 'DELETE_SESSION_UNAUTHORIZE_REJECT'

export const POST_SOCIAL_AUTHORIZE_PENDING = 'POST_SOCIAL_AUTHORIZE_PENDING'
export const POST_SOCIAL_AUTHORIZE_SUCCESS = 'POST_SOCIAL_AUTHORIZE_SUCCESS'
export const POST_SOCIAL_AUTHORIZE_REJECT = 'POST_SOCIAL_AUTHORIZE_REJECT'

export const DELETE_SOCIAL_UNAUTHORIZE_PENDING = 'DELETE_SOCIAL_UNAUTHORIZE_PENDING'
export const DELETE_SOCIAL_UNAUTHORIZE_SUCCESS = 'DELETE_SOCIAL_UNAUTHORIZE_SUCCESS'
export const DELETE_SOCIAL_UNAUTHORIZE_REJECT = 'DELETE_SOCIAL_UNAUTHORIZE_REJECT'

export const PATCH_EMAIL_IDENTITIES_PENDING = 'PATCH_EMAIL_IDENTITIES_PENDING'
export const PATCH_EMAIL_IDENTITIES_SUCCESS = 'PATCH_EMAIL_IDENTITIES_SUCCESS'
export const PATCH_EMAIL_IDENTITIES_REJECT = 'PATCH_EMAIL_IDENTITIES_REJECT'

export const PATCH_EMAIL_IDENTITIES_PASSWORD_PENDING = 'PATCH_EMAIL_IDENTITIES_PASSWORD_PENDING'
export const PATCH_EMAIL_IDENTITIES_PASSWORD_SUCCESS = 'PATCH_EMAIL_IDENTITIES_PASSWORD_SUCCESS'
export const PATCH_EMAIL_IDENTITIES_PASSWORD_REJECT = 'PATCH_EMAIL_IDENTITIES_PASSWORD_REJECT'

export const POST_PHONE_UPDATE_REQUEST_PENDING = 'POST_PHONE_UPDATE_REQUEST_PENDING'
export const POST_PHONE_UPDATE_REQUEST_SUCCESS = 'POST_PHONE_UPDATE_REQUEST_SUCCESS'
export const POST_PHONE_UPDATE_REQUEST_REJECT = 'POST_PHONE_UPDATE_REQUEST_REJECT'

export const POST_PHONE_UPDATE_VERIFY_PENDING = 'POST_PHONE_UPDATE_VERIFY_PENDING'
export const POST_PHONE_UPDATE_VERIFY_SUCCESS = 'POST_PHONE_UPDATE_VERIFY_SUCCESS'
export const POST_PHONE_UPDATE_VERIFY_REJECT = 'POST_PHONE_UPDATE_VERIFY_REJECT'

export const DELETE_ACCOUNT_PHONE_NUMBER_PENDING = 'DELETE_ACCOUNT_PHONE_NUMBER_PENDING'
export const DELETE_ACCOUNT_PHONE_NUMBER_SUCCESS = 'DELETE_ACCOUNT_PHONE_NUMBER_SUCCESS'
export const DELETE_ACCOUNT_PHONE_NUMBER_REJECT = 'DELETE_ACCOUNT_PHONE_NUMBER_REJECT'
